export var MOBILE = 'mobile';
export var DESKTOP = 'desktop';